import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'pollstar-heading',
  template: `
    <div class="pollstar-heading__wrapper">
      <div class="pollstar-heading__overlay"></div>
      <div
        class="pollstar-heading__background"
        *ngIf="imageUrl"
        style="background-size: cover; background-position: right;"
        [ngStyle]="{'background-image': 'url('+imageUrl+')'}"
      >
      </div>
      <div class="pollstar-heading__content">
        <ng-content
          style="display: flex; flex-direction: column; justify-content: stretch; align-items: stretch;"
        ></ng-content>
      </div>
    </div>
  `,
  styles: [// Language=SCSS
    `
      @import "theme-variables";
      @import "common-styles";
      
      :host{
        display: flex;
        width: 100%;
        position: relative;
        flex-direction: column;
        justify-content: stretch;
        align-items: stretch;
      }
      
      .absolute-cover{
        overflow: hidden;
        position: absolute;
        top:0; right: 0; bottom:0; left:0;
        width: 100%;
        height: 100%;
      }
      
      .pollstar-heading {
      
        &__wrapper{
          height: 100%;
        }
      
        &__content {
          display: flex;
          flex:1 1 100%;
          height: 100%;
          width: 100%;
          flex-direction: column;
          justify-content: stretch;
          align-items: stretch;
          position:relative;
          z-index:20;
        }
        &__background {
          @extend .absolute-cover;
          z-index:10;
        }
        &__overlay {
          @extend .absolute-cover;
          z-index:15;
          @extend .header-gradient;
        }
      }
    `
  ]
})
export class PollstarHeadingComponent{
  @Input()
  public imageUrl:string= null
}
